/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_SizeInputs */

const en_onboarding_font_size = /** @type {(inputs: Onboarding_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your font size`)
};

const es_onboarding_font_size = /** @type {(inputs: Onboarding_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tu tamaño de fuente`)
};

/**
* | output |
* | --- |
* | "Choose your font size" |
*
* @param {Onboarding_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_size = /** @type {((inputs?: Onboarding_Font_SizeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_SizeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_size(inputs)
	return en_onboarding_font_size(inputs)
});